<template>
  <div id="app" >
    <div style="margin-bottom: 10px;">
      <el-button @click="quick_zk" size="small">快速展开</el-button>
      <el-button @click="quick_zd" size="small">快速折叠</el-button>
      <el-button @click="quick_ch" size="small">选择用户{{ user_id }}</el-button>
      <el-button @click="quick_gw" size="small">快速归位</el-button>
    </div>
    <!--  @scroll="scroll"  -->
    <el-scrollbar ref="ref_scrollbar" style="height: 100vh;width: 100%;" >
      <TreeChart    v-drag="{type:'name',obj:curObj}" 
      style="position: relative;"
      :style="'top:' + top + 'px;left:' + left + 'px;'"
       isChild="is"  :model="tree" 
       @on-new="newa"  
       @on-update="update"
       @on-clear="clear"
       />
    </el-scrollbar>

    <New v-if="open_edit"  :open_edit="open_edit" :user_id="choose_user_id"  @closeDialog="closeDialogFunc($event, 'edit')"></New>

    <GetUser :is_open="open_getuser" :multi="false" @close="closeGetuserFunc"></GetUser>

  </div>
</template>

<script>
/**
 * 使用方式
 * <TreeChart :model="data" >
 * data 参数格式为树形结构
 * 
 * {
 *  nickName: "xxx",
 *  extend": true, 是否展开
 *  children: [{
 *    nickName: "xxx",
 *    children: []
 *  }]
 * }
*/
import TreeChart from './part/TreeChart'
import UserApi from '@/api/user.js';
import GetUser from '@/components/user/GetUser.vue';
import New from './part/new'
import Recomm_awardApi from '@/api/recomm_award.js';
export default {
  data() {
    return {
      tree: {},
      open_edit:false,
      choose_user_id:0,
      left:0,
      user_id:"",
      /*当前对象*/
      curObj:this,
      left:0,
      top:0,
       /*获取用户是否显示*/
       open_getuser: false,

    }
  },
  components: {
    TreeChart,
    New,
    GetUser
  },
  created() {

    this.getUser();
  },
  directives: {
    /*拖动指令*/
    drag: {
      inserted: function(el, binding) {
        let self = this;
        el.onmousedown = function(event) {
          event = event || window.event;
          let diffX = event.clientX - el.offsetLeft;
          let diffY = event.clientY - el.offsetTop;

          /*鼠标移动*/
          document.onmousemove = function(event) {
            event = event || window.event;
            let moveX = event.clientX - diffX;
            let moveY = event.clientY - diffY;
            binding.value.obj.dragDiv(moveX,moveY,binding.value.type);
          };

          /*鼠标弹起*/
          document.onmouseup = function(event) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods:{

    /*打开获取用户*/
    quick_ch() {
      this.open_getuser = true;
       this.jl = 0;
    },

    /*关闭获取用户*/
    closeGetuserFunc(e) {
      if (e.type != 'error') {
       this.user_id = e.params.user_id
       this.getUser(false);
      }
      this.open_getuser = false;
    },
    
    /*拖动赋值*/
    dragDiv(x, y,type) {
  
       if(type=='name'){
        this.left=x;
        this.top=y;
      }

    },
    quick_gw(){
      this.left=0;
      this.top=0;
       this.jl = 0;
    },
   
    quick_zk(){
      this.getUser(true); 
      this.quick_gw();
           this.jl = 0;
    },
    quick_zd(){
      this.getUser(false);
      this.quick_gw();
           this.jl = 0;
    },
    getUser(flag = false){
      var self = this;

      UserApi.getUserTree({
        user_id:self.user_id,
        flag:flag
      }, true)
        .then(data => {
          console.log(data)
          self.tree = data.data
        })
        .catch(error => {});
    },
    clear(e){
      var user_id = "";
      for(var i=0;i<e.children.length;i++){
        user_id+= ","+e.children[i].user_id
      }
      user_id = user_id.substring(1,user_id.length).trim()
      var self = this;
      UserApi.setLabelBz({
        user_id:user_id,
        branded_zone:0,
      }, true)
        .then(data => {
          console.log(data)
          self.getUser(true);
        })
        .catch(error => {});
    },
    // 修改
    update: function(e,branded_zone){
      var user_id = e.user_id;
      var branded_zone = branded_zone;
      var self = this;

      UserApi.setLabelBz({
        user_id:user_id,
        branded_zone:branded_zone,
      }, true)
        .then(data => {
          console.log(data)
          self.getUser(true);
        })
        .catch(error => {});
    },

    newa(e){
      console.log(e)
        this.choose_user_id = e.user_id
        this.open_edit = true;
    },
            /*关闭弹窗*/
            closeDialogFunc(e, f) {
      if (f == 'edit') {
        this.open_edit = e.openDialog;
    
      }
  },
}
}
</script>

<style lang="scss">
*{
  padding: 0;
  margin: 0;
  #app{
    height: 100%;
    width: 100%;
    padding: 10px;
 
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/tree/index.vue